import { v4 as uuidv4 } from 'uuid';

function dedupeNearMeAgainstTrending(store) {
    const trendingPubIds = new Set(store.popularNowPublishers.map((publisher) => String(publisher.pubId)));
    store.nearMePublishers = store.originNearMePublishers.filter((publisher) => !trendingPubIds.has(String(publisher.pubId)));
    store.observed.nearMePublishers = uuidv4();
}

// Batched two at a time to avoid hammering the backend with a burst of
// simultaneous requests, which was causing intermittent 502/503s (EBL-13022).
 
async function initPublisherData() {
    // Special case: tied to login state, not to whether World data is
    // already loaded, so it runs every time regardless of the guard below.
    this.getRecommendedPublishers();

    if (this.env.worldDataAvailable || this.env.worldDataInflightGuard) {
        if (this.totalSubscribers === null && !this.observed.totalSubscribersLoading) {
            this.getTotalSubscribers();
        }
        return;
    }

    this.env.worldDataInflightGuard = true;
    try {
        // Fire-and-forget: the Hero reads totalSubscribers/totalSubscribersLoading
        this.getTotalSubscribers();

        await Promise.allSettled([this.getFeaturedPublishers(), this.getWhatshotPublishers()]);
        await Promise.allSettled([this.getPopularNowPublishers(), this.getNearMePublishers()]);
        dedupeNearMeAgainstTrending(this);
        await this.getWidgetParamsMap();
        await this.getDirectoryPublishers().catch(() => {});

        this.env.worldDataAvailable = true;
    } finally {
        this.env.worldDataInflightGuard = false;
    }
}

export default initPublisherData;
